import React, { useEffect, useState } from "react";
import { Button, Table } from "antd";

function ContractorDetails({ allData }) {
  console.log(allData);
  const [data, setData] = useState([]);
  // const [dataLimit, setDataLimit] = useState(3);

  useEffect(() => {
    setData(allData);
  }, [allData]);

  // HandleView All Function
  // const handleViewAll = () => {
  //   setDataLimit(dataLimit === 3 ? data.length : 3);
  // };

  // Define the columns for the table
  const columns = [
    {
      title: "Site Address",
      dataIndex: "siteAddress",
    },
    {
      title: "Skilled Labour",
      dataIndex: "skilledLabor",
    },
    {
      title: "Unskilled Labour",
      dataIndex: "unskilledLabor",
    },
    {
      title: "Wages Skilled Labour",
      dataIndex: "wagesSkilledLabor",
    },
    {
      title: "Wages Unskilled Labour",
      dataIndex: "wagesUnskilledLabor",
    },
    {
      title: "Gross Income Monthly",
      dataIndex: "grossIncomeMonthly",
    },
    {
      title: "Gross Income",
      dataIndex: "grossIncome",
    },
    {
      title: "Gross Profit",
      dataIndex: "grossProfit",
    },
    {
      title: "Contract Cost",
      dataIndex: "contractCost",
    },
    {
      title: "Completion Time",
      dataIndex: "completionTime",
    },
    {
      title: "Material Cost",
      dataIndex: "materialCost",
    },
    {
      title: "Remark",
      dataIndex: "remark",
    },
    {
      title: "Build Up Area",
      dataIndex: "buildupArea",
    },
    {
      title: "Total Material Cost",
      dataIndex: "totalMaterialCost",
    },
    {
      title: "Total Wages",
      dataIndex: "totalWages",
    },
  ];

  return (
    <div className="container">
      <div className="row">
        {data && data.length > 0 ? (
          <div className="col-12 mb-4">
            <div className="card">
              <div className="card-body">
                <div className="table-responsive">
                  <Table
                    dataSource={data} // Limiting data display based on dataLimit
                    columns={columns}
                    pagination={false}
                    rowKey={(record) => record.id} // Assuming each record has a unique id
                  />
                  {/* {data.length > 3 && (
                    <Button
                      onClick={handleViewAll}
                      block
                      style={{ width: "100%", marginTop: "10px" }}
                    >
                      {dataLimit === 3 ? "View All" : "Show Less"}
                    </Button>
                  )} */}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="col-12 mb-4">
            <div className="card text-center">
              <div className="card-body">
                <p>No data available</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ContractorDetails;
